import { render } from "./ExamInfo.vue?vue&type=template&id=142f5ec2&scoped=true"
import script from "./ExamInfo.vue?vue&type=script&lang=js"
export * from "./ExamInfo.vue?vue&type=script&lang=js"

import "./ExamInfo.vue?vue&type=style&index=0&id=142f5ec2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-142f5ec2"]])

export default __exports__